import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-505460cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_rule",
  ref: "addPriceRuleModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_rule_header"
}
const _hoisted_5 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_6 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_rule_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_rule_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_rule_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_11 = { class: "row mb-7" }
const _hoisted_12 = { class: "col-md-6 form-group" }
const _hoisted_13 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_14 = { class: "col-md-6 form-group" }
const _hoisted_15 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "col-md-6 form-group" }
const _hoisted_20 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = { class: "col-md-6 form-group" }
const _hoisted_23 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_24 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " % ", -1))
const _hoisted_26 = { class: "col-md-6 form-group" }
const _hoisted_27 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_28 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " % ", -1))
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = { class: "col-md-6 form-group" }
const _hoisted_32 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_33 = { class: "col-md-6 form-group" }
const _hoisted_34 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_35 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " % ", -1))
const _hoisted_37 = { class: "row mb-7" }
const _hoisted_38 = { class: "col-md-6 form-group" }
const _hoisted_39 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_40 = { class: "col-md-6 form-group" }
const _hoisted_41 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_42 = { class: "row mb-7" }
const _hoisted_43 = { class: "col-md-6 form-group" }
const _hoisted_44 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_45 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_46 = { class: "col-md-6 form-group" }
const _hoisted_47 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_48 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_49 = { class: "modal-footer flex-center" }
const _hoisted_50 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_51 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_52 = { class: "indicator-label" }
const _hoisted_53 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_54 = { class: "indicator-progress" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.id == 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.$t("merchants.addPriceRules")), 1))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.$t("merchants.editPriceRules")), 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("merchants.distributionMode")), 1),
                    _createVNode(_component_el_form_item, { prop: "service_mode" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.service_mode,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.service_mode) = $event)),
                          clearable: "",
                          placeholder: _ctx.$t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.b2BReselling'),
                              value: 10
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.affiliateProgram'),
                              value: 15
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.travelRetailProgram'),
                              value: 20
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("merchants.salesChannel")), 1),
                    _createVNode(_component_el_form_item, { prop: "retail_channel_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.retail_channel_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.retail_channel_id) = $event)),
                          filterable: "",
                          placeholder: _ctx.$t('common.plsEnter')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("merchants.brand")), 1),
                    _createVNode(_component_el_form_item, { prop: "brand_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.brand_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                          filterable: "",
                          remote: "",
                          clearable: "",
                          "reserve-keyword": "",
                          placeholder: _ctx.$t('common.plsEnter'),
                          "remote-method": _ctx.searchBrandItems,
                          loading: _ctx.brandLoading
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("merchants.category")), 1),
                    _createVNode(_component_el_form_item, { prop: "category_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "category_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_cascader, {
                              options: _ctx.tableArr,
                              "show-all-levels": false,
                              props: _ctx.propData,
                              clearable: "",
                              filterable: "",
                              lazy: "",
                              modelValue: _ctx.formData.category_id,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.category_id) = $event)),
                              onChange: _ctx.parentChange,
                              placeholder: _ctx.$t('common.plsSelect')
                            }, null, 8, ["options", "props", "modelValue", "onChange", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("merchants.commission")), 1),
                    _createVNode(_component_el_form_item, { prop: "commission" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.formData.commission,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.commission) = $event)),
                            precision: 2,
                            step: 0.01,
                            min: 0,
                            max: 100,
                            controls: false,
                            placeholder: _ctx.$t('common.plsEnter')
                          }, null, 8, ["modelValue", "step", "placeholder"]),
                          _hoisted_25
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("merchants.discount")), 1),
                    _createVNode(_component_el_form_item, { prop: "discount" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.formData.discount,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.discount) = $event)),
                            precision: 2,
                            step: 0.01,
                            min: 0,
                            max: 100,
                            controls: false,
                            placeholder: _ctx.$t('common.plsEnter')
                          }, null, 8, ["modelValue", "step", "placeholder"]),
                          _hoisted_29
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("merchants.vatDeductible")), 1),
                    _createVNode(_component_el_form_item, { prop: "vat_deductible" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.formData.vat_deductible,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.vat_deductible) = $event)),
                          "active-value": 1,
                          "inactive-value": 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("merchants.distributionMargin")), 1),
                    _createVNode(_component_el_form_item, { prop: "distribution_margin" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_el_input, {
                            class: "text-start w-100",
                            value: _ctx.getdistributionMargin,
                            placeholder: _ctx.$t('common.plsEnter'),
                            disabled: true
                          }, null, 8, ["value", "placeholder"]),
                          _hoisted_36
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("merchants.basedOn")), 1),
                    _createVNode(_component_el_form_item, { prop: "based_on" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.based_on,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.based_on) = $event)),
                          clearable: "",
                          placeholder: _ctx.$t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.netPrice'),
                              value: 10
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.grossPrice'),
                              value: 20
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("merchants.priceBaseline")), 1),
                    _createVNode(_component_el_form_item, { prop: "price_baseline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.price_baseline,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.price_baseline) = $event)),
                          clearable: "",
                          placeholder: _ctx.$t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.euLocalPrice'),
                              value: 10
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.hkLocalPrice'),
                              value: 15
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.chinaLocalPrice'),
                              value: 20
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              label: _ctx.$t('merchants.macauLocalPrice'),
                              value: 25
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("merchants.minAmount")), 1),
                    _createVNode(_component_el_form_item, { prop: "min_amount" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.formData.min_amount,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.min_amount) = $event)),
                            precision: 0,
                            step: 1,
                            min: 0,
                            max: 99999999,
                            controls: false,
                            placeholder: _ctx.$t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("merchants.maxAmount")), 1),
                    _createVNode(_component_el_form_item, { prop: "max_amount" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_el_input_number, {
                            class: "text-start w-100",
                            modelValue: _ctx.formData.max_amount,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.max_amount) = $event)),
                            precision: 0,
                            step: 1,
                            min: 0,
                            max: 99999999,
                            controls: false,
                            placeholder: _ctx.$t('common.plsEnter')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_50, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_51, [
                _createElementVNode("span", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_54, [
                  _createTextVNode(_toDisplayString(_ctx.$t("common.pleaseWait")) + " ", 1),
                  _hoisted_55
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}